import React, { useContext, useEffect, useState } from 'react'
import { Row, Col, Button, Spinner } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { listRole, listAccessControl, addAccessControl, removeAccessControl, deleteRole } from '../Network/Role'
import { Container, Toggle, HeaderTitle } from '../Library'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserTag, faPen, faTrash, faLock, faQuestion, faCloudSun, faWrench, faUser, faScroll, faHouseUser, faNewspaper, faCalendarAlt, faImage, faMailBulk, faMobileAlt, faGlobeAsia, faTabletAlt, faCalendarCheck, faCube, faWalking } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom'
import { setDocumentTitle } from '../AppTitle'
import "./Role.css"
import { AlertModalContext } from '../Library/AlertModalContext'

const accessIdentifier = {
    WIDGET: "WIDGET",
    USER: "USER",
    NEWS: "NEWS",
    GALLERY: "GALLERY",
    CALENDAR: "CALENDAR",
    REPAIR: "REPAIR",
    LOG: "LOG",
    RENTAL: "RENTAL",
    INBOX: "INBOX",
    BOOKING: "BOOKING",
    DELIVERY: "DELIVERY",
    ROLE: "ROLE",
    VISITOR: "VISITOR"
}

function Role() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.role
    const alertModal = useContext(AlertModalContext)
    const notify = useContext(NotifyContext)
    const history = useHistory()
    const page = 1
    const size = 900
    const [isLoading, setLoading] = useState(false)
    const [role, setRole] = useState([])
    const [accessItem, setAccessItem] = useState([])
    const [selectedRole, setSelectedRole] = useState(null)
    const [selectedAccessControl, setSelectedAccessControl] = useState([])

    const fetchRole = () =>{
        setLoading(true)
        listRole(page, size,
            (data)=>{
                setRole(data)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const addAccessItem = (roleId, accessId) =>{
        addAccessControl(accessId, roleId,
            (data)=>{
                setSelectedAccessControl(data.accessControlItems)
                fetchRole()
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const removeAccessItem = (roleId, accessId) =>{
        removeAccessControl(accessId, roleId,
            (data)=>{
                setSelectedAccessControl(data.accessControlItems)
                fetchRole()
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    const deleteRoleItem = (roleId) =>{
        alertModal.setTitle(lang.delete_role)
        alertModal.setDescription(lang.sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    deleteRole(roleId,
                        ()=>{
                            setSelectedRole(null)
                            fetchRole()
                            notify.showNotify(lang.deleted_role, lang.deleted_role_desc, 0)
                        },
                        (error)=>{
                            notify.showNotify("Something wrong", error.message, 2)
                            setLoading(false)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    useEffect(()=>{
        setDocumentTitle("Permission")
        const fetchAccessItem = () =>{
            listAccessControl(page, size,
                (data)=>{
                    setAccessItem(data)
                },
                (error)=>{})
        }

        fetchRole()
        fetchAccessItem()
    },[])

    return (
        <Container id="role" topbarTitle={langCx.lang.sidebar.role}>
            {/* <div className="top-header">
                <div className="title-header">{lang.role}</div>
                <div style={{ display: 'flex', alignItems: 'center'}}>
                    { isLoading ?
                    <Spinner 
                    variant="primary" 
                    style={{marginRight: 20}}
                    animation="border"/>
                    : null
                    }
                    <Button
                    onClick={()=>history.push("/role/add")}>
                        {lang.add_role}
                    </Button>
                </div>
            </div> */}
            <HeaderTitle 
            title={lang.role}
            customRight={
                <>
                { isLoading ?
                    <Spinner 
                    variant="primary" 
                    style={{marginRight: 20}}
                    animation="border"/>
                : null
                }
                <Button
                onClick={()=>history.push("/role/add")}>
                    {lang.add_role}
                </Button>
                </>
            }
                />
            <Row>
                <Col sm={6} md={12} lg={6}>
                    <div className="role-container" style={{marginBottom: 20}}>
                        { role.map((item, key)=>
                        <RoleItem
                        key={key}
                        title={item.roleName}
                        roleLevel={item.level}
                        isSelected={selectedRole === item.id ? true:false}
                        onClick={()=>{
                            setSelectedRole(item.id)
                            setSelectedAccessControl(item.accessControlItems)
                        }}
                        onEditClick={()=>{
                            history.push("/role/edit/"+item.id)
                        }}
                        onDeleteClick={()=>{
                            deleteRoleItem(item.id)
                        }}
                        />
                        )}
                    </div>
                </Col>
                <Col sm={6} md={12} lg={6}>
                    <div className="role-container">
                        { selectedRole !== null ?
                        <>
                        { accessItem.map((item, key)=>
                        <AccessControlItem
                        key={key}
                        title={item.description}
                        isTurnon={selectedAccessControl.some(el=>el.id === item.id)}
                        forMobile={item.forMobile}
                        forWebsite={item.forWebsite}
                        forTablet={item.forTablet}
                        identifier={item.identifier}
                        onToggle={()=>{
                            if(!selectedAccessControl.some(el=>el.id === item.id)){
                                addAccessItem(selectedRole, item.id)
                            }else{
                                removeAccessItem(selectedRole, item.id)
                            }
                        }}
                        />
                        )}
                        </>
                        : 
                        <div className="not-selected-role">
                            <div>
                                <div>
                                    <FontAwesomeIcon icon={faLock} className="icon"/>
                                </div>
                                <div>{lang.select_role}</div>
                            </div>
                        </div>
                        }
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

function RoleItem(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.role
    const roleLevel = props.roleLevel
    var roleLabel = ""

    switch(roleLevel){
        case(1):
            roleLabel = lang.super_admin
            break
        case(2):
            roleLabel = lang.high_level
            break
        case(3):
            roleLabel = lang.med_level
            break
        default:
            roleLabel = lang.low_level
            break
    }

    return(
        <div 
        className="role-control-item"
        style={{
            color: props.isSelected ? "white": "black",
            backgroundColor: props.isSelected ? "#0275d8": null
        }}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        onClick={props.onClick}>
            <div style={{display: 'flex'}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <FontAwesomeIcon icon={faUserTag} className="icon"/>
                </div>
                <div style={{marginLeft: 13}}>
                    <div className="title">{props.title}</div>
                    <div className="desc" style={{ color: props.isSelected ? "white" : "grey"}}>{roleLabel}</div>
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <Button
                size="sm"
                onClick={(e)=>{
                    e.preventDefault()
                    props.onEditClick()
                }}>
                    <FontAwesomeIcon icon={faPen}/>
                </Button>
                <Button
                size="sm"
                style={{marginLeft: 10}}
                variant="danger"
                onClick={(e) => {
                    e.preventDefault()
                    props.onDeleteClick()
                }}>
                    <FontAwesomeIcon icon={faTrash}/>
                </Button>
            </div>
        </div>
    )
}

function AccessControlItem({ title, identifier, forMobile, forWebsite, forTablet, isTurnon, onToggle }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.role
    let icon

    switch(identifier){
        case(accessIdentifier.WIDGET):
            icon = faCloudSun
            break
        case(accessIdentifier.USER):
            icon = faUser
            break
        case(accessIdentifier.NEWS):
            icon = faNewspaper
            break
        case(accessIdentifier.CALENDAR):
            icon = faCalendarAlt
            break
        case(accessIdentifier.GALLERY):
            icon = faImage
            break
        case(accessIdentifier.REPAIR):
            icon = faWrench
            break
        case(accessIdentifier.LOG):
            icon = faScroll
            break
        case(accessIdentifier.RENTAL):
            icon = faHouseUser
            break
        case(accessIdentifier.INBOX):
            icon = faMailBulk
            break
        case(accessIdentifier.BOOKING):
            icon = faCalendarCheck
            break
        case(accessIdentifier.DELIVERY):
            icon = faCube
            break
        case(accessIdentifier.ROLE):
            icon = faLock
            break
        case(accessIdentifier.VISITOR):
            icon = faWalking
            break
        default:
            icon = faQuestion
            break
    }

    const PlatformIndicator = ({ icon, title }) => {
        return(
            <div className="platform-indicator">
                <FontAwesomeIcon icon={icon} style={{ width: 18 }}/>
            </div>
        )
    }

    return(
        <div className="access-control-item">
            <div className="icon">
                <FontAwesomeIcon icon={icon}/>
            </div>
            <div style={{flex: 1}}>
                <div>{title}</div>
                <div style={{ marginTop: 6, display: 'flex' }}>
                    { forMobile ? <PlatformIndicator icon={faMobileAlt} title={lang.mobile}/> : null }
                    { forWebsite ? <PlatformIndicator icon={faGlobeAsia} title={lang.web_admin}/> : null }
                    { forTablet ? <PlatformIndicator icon={faTabletAlt} title={lang.tablet}/> : null}
                </div>
            </div>
            <Toggle
            isTurnon={isTurnon}
            style={{width:60}}
            onChange={onToggle}
            />
        </div>
    )
}

export default Role
